export enum ContextEnum {
  HomePage = 'hp',
  DestinationsResults = 'list_destinations_results',
  DealsResults = 'list_deals_result',
  MapDestinationsResults = 'map_destinations_results',
  MapDealsResults = 'map_deals_result',
  CovidInfoLayer = 'covid_info_layer',
  SearchDealsResults = 'search_deals_result',
  WaitingPage = 'waiting_page',
}
